import { CommonListProps } from "@/common/types/ListFromApi.types";
import { IMeta } from "@/core/libs/api/interfaces/meta.interface";
import { IMessageBar } from "@/core/libs/message-bar";

export enum LinesActionsTypes {
  CREATE_REQUEST = "lines/CREATE_REQUEST",
  CREATE_FAIL = "lines/CREATE_FAIL",
  CREATE_SUCCESS = "lines/CREATE_SUCCESS",
  DISMISS_MESSAGE = "lines/DISMISS_MESSAGE",
  EDIT_REQUEST = "lines/EDIT_REQUEST",
  EDIT_FAIL = "lines/EDIT_FAIL",
  EDIT_SUCCESS = "lines/EDIT_SUCCESS",
  LIST_REQUEST = "lines/LIST_REQUEST",
  LIST_FAIL = "lines/LIST_FAIL",
  LIST_SUCCESS = "lines/LIST_SUCCESS"
}

export interface LinesState {
  isLoadingList: boolean;
  list?: ListOfLines;
  message?: IMessageBar;
}
interface Plan {
  id: number;
  name: string;
}

interface Carrier {
  id: number;
  name: string;
  logo: string;
}

interface LineItem {
  id?: number;
  number?: string;
  lineStatus?: string;
  carrierStatus?: string;
  reservedBetween?: any;
  plans?: Plan[];
  carrier?: Carrier;
  contractItems?: any;
  contract?: any;
}

interface ListOfLines extends CommonListProps {
  items?: LineItem[];
  meta: IMeta;
}

interface CreateRequest {
  type: LinesActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: LinesActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: LinesActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: LinesActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: LinesActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: LinesActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: LinesActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: LinesActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: LinesActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: LinesActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfLines;
  };
}

export type LinesReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
